import $ from 'jquery';

class ContactModal {
  constructor() {
    this.showModalBtn = $('.js-modal-show-btn');

    if (!this.showModalBtn.length) {
      return;
    }

    this.showModal();
  }

  showModal() {
    this.showModalBtn.on('click', e => {
      e.preventDefault();

      const self = $(e.currentTarget);
      this.modalId = self.attr('href');

      this.openModal();
    });
  }

  openModal() {
    this.modal = $(this.modalId);

    if (this.modal.length) {
      this.modalBox = this.modal.find('.js-modal-box');

      this.modal
        .addClass('is-open')
        .stop()
        .animate(
          {
            opacity: 1,
          },
          200,
          () => {
            this.closeModal();
          },
        );

      this.modalBox.addClass('is-open');
    }
  }

  closeModal() {
    const closeBtn = this.modal.find('.js-close-modal');

    closeBtn.on('click', () => {
      this.modalBox.removeClass('is-open');

      this.modal.stop().animate(
        {
          opacity: 0,
        },
        200,
        () => {
          this.modal.removeClass('is-open');
        },
      );
    });
  }
}

export default ContactModal;



// WEBPACK FOOTER //
// ./src/scripts/modules/contact-modal.js